import { useState } from "react";

import { TextField } from "#components/TextField";

import type { EnterValueColumn } from "./types";

export interface EnterValueColumnProps {
  column: EnterValueColumn;
  onSelect: (value: string) => void;
  selectedValue?: string;
}

export function EnterValueColumn({ column, onSelect, selectedValue }: EnterValueColumnProps) {
  const [inputValue, setInputValue] = useState(selectedValue || "");
  const [error, setError] = useState("");

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const trimmedValue = inputValue.trim();

      // Basic validation - value should not be empty
      if (!trimmedValue) {
        setError("Please enter a value");
      } else {
        setError("");
        onSelect(trimmedValue);
      }
    }
  };

  return (
    <TextField
      assistiveText={error}
      className="w-full gap-0 px-2 py-1"
      inputProps={{
        placeholder: column.placeholder,
        onKeyDown: handleKeyPress,
        className: "h-[1.625rem] text-body-small",
      }}
      isInvalid={!!error}
      onChange={setInputValue}
      value={inputValue}
    />
  );
}
